import React from 'react'
import { Global, css } from '@emotion/core'

import DiaEOT from '../assets/type/Dia-Regular.eot'
import DiaWOFF from '../assets/type/Dia-Regular.woff'

import reset from './reset'
import {
  fontFace
} from './utils'

export default props => {
  return <Global
    styles={ theme => css`
      ${ reset }

      ${fontFace(
        `'Dia-Regular'`,
        {
          eot: DiaEOT,
          woff: DiaWOFF,
        },
        400,
        'normal'
      )}

      body {
        -webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: 'grayscale';
      }
    `}
    />
}